package com.milta.feature.profile.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class ConfirmPhoneChangeRequest(
    val code: String,
)
